<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-08-01 17:51:15
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2023-08-04 09:14:52
-->
<template>
  <div class="con-wrap">
    <Add :accountType="accountType" />
  </div>
</template>

<script>
import Add from "@/components/RegionAccount/Add";
export default {
  name: "AddProvince",
  components: { Add },
  data() {
    return {
      accountType: "province",
    };
  },
};
</script>
<style lang="scss" scoped>
.con-wrap {
  overflow: auto;
}
</style>
